<script setup>
import bgSmile from '@/assets/img/bg-smilepicture.png'
</script>

<template>
    <section class="wrapper" :style="{
        backgroundImage: `url(${bgSmile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }">
        <div class="container py-14 py-md-16">
            <h1 class="display-1 mb-3 text-white text-center">
                How <span class="text-secondary">We Work</span>
            </h1>
            <p class="lead text-white text-center mb-10">
                Our collaborative process ensures that every project we undertake is a true reflection of our client's
                vision, values, and goals. From the initial concept to the final delivery, we work closely with our
                clients to bring their stories to life through compelling visuals and engaging narratives.
            </p>

            <div class="row gx-lg-8 gx-xl-12 gy-6 process-wrapper line position-relative">
                <!-- Step 01 -->
                <div class="col-md-6 col-lg-4 step">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <span class="number">01</span>
                    </span>
                    <h4 class="text-white mb-1">Initial brief with Client</h4>
                    <p class="text-white mb-0">
                        Clients to provide an overview and initial information about the project to be worked on.
                    </p>
                    <i class="uil uil-arrow-right step-arrow"></i>
                </div>

                <!-- Step 02 -->
                <div class="col-md-6 col-lg-4 step">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <span class="number">02</span>
                    </span>
                    <h4 class="text-white mb-1">Concept Creative Presentation</h4>
                    <p class="text-white mb-0">
                        We breakdown into a storyboard including: Frame by frame story line, colour grading, and other
                        video treatments.
                    </p>
                    <i class="uil uil-arrow-right step-arrow"></i>
                </div>

                <!-- Step 03 -->
                <div class="col-md-6 col-lg-4 step">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <span class="number">03</span>
                    </span>
                    <h4 class="text-white mb-1">Pre Production</h4>
                    <p class="text-white mb-0">
                        Director Treatment, Storyboards, Talent (Model), Art, Wardrobe, Location.
                    </p>
                </div>

                <!-- Step 04 -->
                <div class="col-md-6 col-lg-4 step">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <span class="number">04</span>
                    </span>
                    <h4 class="text-white mb-1">Production</h4>
                    <p class="text-white mb-0">
                        We execute what was planned in pre-production. Realize what’s on the storyboard
                    </p>
                    <i class="uil uil-arrow-right step-arrow"></i>
                </div>

                <!-- Step 05 -->
                <div class="col-md-6 col-lg-4 step">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <span class="number">05</span>
                    </span>
                    <h4 class="text-white mb-1">Post Production</h4>
                    <p class="text-white mb-0">
                        Video : Compositing, Graphics, Grading.<br>
                        Audio : Voice Over, Music, Sound Mixing
                    </p>
                    <i class="uil uil-arrow-right step-arrow"></i>
                </div>

                <!-- Step 06 -->
                <div class="col-md-6 col-lg-4 step">
                    <span class="icon btn btn-circle btn-lg btn-soft-primary disabled mb-4">
                        <span class="number">06</span>
                    </span>
                    <h4 class="text-white mb-1">Delivery</h4>
                    <p class="text-white mb-0">
                        Deliver the final creative output
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.wrapper {
    position: relative;
}

.wrapper::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 0;
}

.wrapper>.container {
    position: relative;
    z-index: 1;
}

.btn-soft-primary {
    background-color: transparent !important;
    border: 2px solid #ffae0b;
    color: #ffae0b;
}

.process-wrapper.line [class*="col-"]:after {
    border-top-color: transparent;
}

/* Icon step panah */
.step {
    position: relative;
}

.step-arrow {
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    color: #ffae0b;
}

.step:last-child .step-arrow {
    display: none;
}

/* ===============================
   HOW WE WORKS RESPONSIVE ARROW
   =============================== */
@media (max-width: 991.98px) {
    .step-arrow {
        display: none;
    }
}
</style>
